import { useAuth } from '@/legacy/redux';
import {
  ALL_ROLES as SHARED_ALL_ROLES,
  Roles as SharedRoles,
  type Role,
} from "@packages/commons";

// Note these 'hooks' are not react hooks, they are just functions that return a boolean
// Using a proper 'hook' was causing issues with react router

export const Roles = SharedRoles;
export type Roles = Role;
export const ALL_ROLES = SHARED_ALL_ROLES;
export const ADMIN_ROLES = [Roles.Owner, Roles.SuperAdmin, Roles.TimesheetAdmin];
export const SUPER_ADMIN = [Roles.SuperAdmin];
export const PROJECT_ROLES = [Roles.ProjectReader, Roles.ProjectWriter, Roles.ProjectTechnical];

const useRoles = () => {
  const { user } = useAuth();
  return user?.roles ?? [];
};

const authorise = (role: string | string[]) => {
  const userRoles = useRoles();
  const roles = Array.isArray(role) ? role : [role];
  return roles.some(role => userRoles.includes(role));
};

export const useIsSuperAdmin = () => {
  return authorise([Roles.SuperAdmin]);
};

export const useIsAdmin = () => {
  return authorise(ADMIN_ROLES);
};

export const useIsOwner = () => {
  return authorise([Roles.Owner]);
};

export const useIsProjectWriter = () => {
  return authorise([Roles.ProjectWriter]);
};

export const useIsProjectTechnicalWriter = () => {
  return authorise([Roles.ProjectWriter, Roles.ProjectTechnical]);
}

export const useHasRole = (role: string | string[]) => {
  return authorise(role)
};

export const useAuthorise = () => {
  return (role: string | string[]) => authorise(role)
};
